var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "quote-form" } },
    [
      _c(
        "b-form-group",
        { attrs: { label: "Interested In", "label-cols-sm": "3" } },
        [
          _c("b-form-select", {
            attrs: { options: _vm.enquiryTypes },
            model: {
              value: _vm.formData.enquiry,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "enquiry", $$v)
              },
              expression: "formData.enquiry",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: { label: "Price Range / Standard", "label-cols-sm": "3" },
          scopedSlots: _vm._u([
            {
              key: "description",
              fn: function () {
                return [
                  _vm._v(
                    "To find out more about our Fine Art Guild framing standards, "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "/picture-framing-standards/fine-art-trade-guild-picture-framing-standards",
                        target: "_blank",
                      },
                    },
                    [_vm._v("click here")]
                  ),
                  _vm._v("."),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.framingStandards },
            model: {
              value: _vm.formData.standard,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "standard", $$v)
              },
              expression: "formData.standard",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            "label-cols-sm": "3",
            label: "A Brief Description",
            description:
              "Please describe your enquiry as clearly as possible - the more we know, the better we can help you.",
          },
        },
        [
          _c("b-form-textarea", {
            model: {
              value: _vm.formData.description,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "description", $$v)
              },
              expression: "formData.description",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            "label-cols-sm": "3",
            label: "Images",
            description:
              "Photos can help us find a style/colour that matches your needs - but please remember that every device shows colours differently.",
          },
        },
        [
          _c("vue-dropzone", {
            attrs: { id: "images", options: _vm.dropzoneOptions },
            on: { "vdropzone-success-multiple": _vm.imagesUploaded },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        { attrs: { label: "Size", "label-cols-sm": "3" } },
        [
          _c("b-form-input", {
            attrs: { placeholder: "e.g. 40 x 50cm" },
            model: {
              value: _vm.formData.size,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "size", $$v)
              },
              expression: "formData.size",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        { attrs: { label: "Colour / Style", "label-cols-sm": "3" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-form-input", {
                    attrs: { placeholder: "Colour" },
                    model: {
                      value: _vm.formData.colour,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "colour", $$v)
                      },
                      expression: "formData.colour",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.styles },
                    model: {
                      value: _vm.formData.style,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "style", $$v)
                      },
                      expression: "formData.style",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("hr"),
      _c(
        "b-form-group",
        { attrs: { label: "Your Location", "label-cols-sm": "3" } },
        [
          _c("b-form-radio-group", {
            attrs: { options: _vm.locations },
            model: {
              value: _vm.formData.location,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "location", $$v)
              },
              expression: "formData.location",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        { attrs: { label: "Your Details", "label-cols-sm": "3" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("b-form-input", {
                    attrs: { placeholder: "Name" },
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("b-form-input", {
                    attrs: { placeholder: "Email" },
                    model: {
                      value: _vm.formData.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "email", $$v)
                      },
                      expression: "formData.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("b-form-input", {
                    attrs: { placeholder: "Phone" },
                    model: {
                      value: _vm.formData.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "phone", $$v)
                      },
                      expression: "formData.phone",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            "label-cols-sm": "3",
            description:
              "We will not store your data for any purposes other than replying to this quote request.",
          },
        },
        [
          _c(
            "b-form-checkbox",
            {
              model: {
                value: _vm.contactEnabled,
                callback: function ($$v) {
                  _vm.contactEnabled = $$v
                },
                expression: "contactEnabled",
              },
            },
            [
              _vm._v(
                "I am happy to be contacted via e-mail or phone regarding this enquiry"
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "b-form-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            { attrs: { "offset-sm": "3", sm: "6" } },
            [
              _c(
                "vue-recaptcha",
                {
                  ref: "recaptcha",
                  attrs: { sitekey: _vm.recaptchaKey, size: "invisible" },
                  on: {
                    verify: _vm.recaptchaVerified,
                    expired: _vm.recaptchaExpired,
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "brand",
                        block: "",
                        disabled: _vm.isSubmitDisabled,
                      },
                    },
                    [_vm._v("Request Free Quote")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }